// operate
// 操作日志
import layout from '@/layout/index.vue'
export default {
  path: '/',
  component: layout,
  redirect: '/rotation',
  name: 'operate',
  children: [
    {
      path: '/operate',
      component: () => import('@/views/operate-log/index.vue'),
      meta: {
        title: '操作日志',
        icon: 'caozuo'
      }
    }
  ]
}
